<template>
  <div class="row">
    <div class="col-md-1">
      <img
        src="@/assets/images/ic-arrow-left.svg"
        width="30"
        class="arrow mb-30"
        alt
        @click="changeComponent('Details')"
      />
    </div>
    <div class="col-md-11">
      <h2 class="header-title">Change MPIN</h2>
      <div class="row mt-30">
        <div class="col-md-6">
          <b-form @submit="changeMPIN">
            <div class="form-group">
              <label for="oldPin">Old MPIN</label>
              <div class="pos-rlt">
                <b-form-input
                  :class="['form-control mpin', { 'password-on': mpinToggleOld }]"
                  id="oldPin"
                  placeholder="Enter MPIN"
                  v-model="form.pin.oldPin"
                  maxlength="4"
                  required
                  type="text"
                  @keydown.native="isNumber($event)"
                  @keyup.native="trimNumber('oldPin')"
                  pattern="[0-9]*"
                  inputmode="numeric"
                ></b-form-input>

                <img
                  src="@/assets/images/eye-fill.svg"
                  alt
                  class="eye-masking"
                  @click="mpinToggleOld = !mpinToggleOld"
                />
              </div>
            </div>
            <div class="invalid-feedback d-block mb-2">
              {{ invalidFeedback("oldPin") }}
            </div>
            <div class="form-group">
              <label for="newPin">MPIN</label>
              <div class="pos-rlt">
                <b-form-input
                  :class="['form-control mpin', { 'password-on': mpinToggleNew }]"
                  id="newPin"
                  placeholder="Enter MPIN"
                  v-model="form.pin.newPin"
                  maxlength="4"
                  required
                  type="text"
                  @keydown.native="isNumber($event)"
                  @keyup.native="trimNumber('newPin')"
                  pattern="[0-9]*"
                  inputmode="numeric"
                ></b-form-input>

                <img
                  src="@/assets/images/eye-fill.svg"
                  alt
                  class="eye-masking"
                  @click="mpinToggleNew = !mpinToggleNew"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="confirmPin">Confirm New MPIN</label>
              <div class="pos-rlt">
                <b-form-input
                  :class="['form-control mpin', { 'password-on': mpinToggleConfirm }]"
                  id="confirmPin"
                  placeholder="Confirm New MPIN"
                  v-model="form.pin.confirmPin"
                  maxlength="4"
                  required
                  type="text"
                  @keydown.native="isNumber($event)"
                  @keyup.native="trimNumber('confirmPin')"
                  pattern="[0-9]*"
                  inputmode="numeric"
                ></b-form-input>
                <img
                  src="@/assets/images/eye-fill.svg"
                  alt
                  class="eye-masking"
                  @click="mpinToggleConfirm = !mpinToggleConfirm"
                />
              </div>
            </div>
            <div class="invalid-feedback d-block mb-2">
              {{ invalidFeedback("pin") }}
            </div>
            <div class="invalid-feedback d-block mb-2">
              {{ invalidFeedback("confirmPin") }}
            </div>
            <button
              type="submit"
              class="btn btn-core fw mt-20"
              :disabled="
                authIsLoading || merchantIsLoading || customerIsLoading
              "
              v-if="webDesign !== null && webDesign.design !== null"
              :style="{ 
                backgroundColor: webDesign.design.main_color+'!important',
                border: 'none !important',
                color: webDesign.design.button_text_color+'!important'
              }"
            >
              PROCEED
            </button>
            <button
              type="submit"
              class="btn btn-core fw mt-20"
              :disabled="
                authIsLoading || merchantIsLoading || customerIsLoading
              "
              v-else
            >
              PROCEED
            </button>            
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {},
  data() {
    return {
      form: {
        pin: {
          oldPin: "",
          newPin: "",
          confirmPin: ""
        }
      },
      mpinToggleOld: false,
      mpinToggleNew: false,
      mpinToggleConfirm: false
    };
  },
  computed: {
    ...mapState("auth", {
      token: state => state.token,
      authErrors: state => state.errors,
      authIsLoading: state => state.loading
    }),
    ...mapState("customer", {
      customer: state => state.user,
      customerErrors: state => state.errors,
      customerIsLoading: state => state.loading
    }),
    ...mapState("merchant", {
      subdomain: state => state.subdomain,
      customerPortalToken: state => state.customerPortalToken,
      merchantIsLoading: state => state.loading,
      merchantErrors: state => state.errors
    }),
    ...mapState("estore", {
      webDesign: state => state.webDesign
    }),
  },
  methods: {
    changeComponent(component) {
      this.$emit("change-component", component);
      this.$emit("change-title", "Your MPIN has been changed successfully!");
    },
    changeMPIN: async function(evt) {
      evt.preventDefault();
      this.$store.dispatch("customer/resetErrors");

      let request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          oldpin: this.form.pin.oldPin,
          newPin: this.form.pin.newPin,
          confirmPin: this.form.pin.confirmPin
        }
      };

      let _this = this;
      await this.$store.dispatch("customer/updatePin", request).then(() => {
        if (_this.customerErrors == null) {
          _this.changeComponent("Success");
        }
      });
    },
    invalidFeedback(field) {
      if (this.customerErrors == null) {
        return "";
      }
      return this.customerErrors.errors[field];
    },
    state(field) {
      if (this.customerErrors == null) {
        return false;
      }
      return this.customerErrors.errors[field] ? false : true;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      const maxlength = 4;
      const fieldLength = evt.target.value.length;
      if (charCode >= 48 && charCode <= 57 && fieldLength < maxlength || charCode === 8) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    trimNumber: function(ref) {
      this.$nextTick(() => {
        this.form.pin[ref] = this.form.pin[ref].replace(/\D/g, "");
      }, 300);
    }
  }
};
</script>

<style lang="scss" scoped>
input[type="text"].mpin:not(.password-on) {
  -webkit-text-security: disc;
}
</style>
